import { type FC } from 'react';
import { Text } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';
import { useText } from 'helpers/hooks/useText';
import { Section } from 'components';

type Props = WithOptionalDataTest;

export const Terms: FC<Props> = () => {
  const { getText } = useText();

  return (
    <Section title="Terms and Condition">
      <div className="script-box">
        <Text.$ size={Text.Size.MD} mark>
          {getText('booking.payment.cancellationPolicy')}
        </Text.$>
      </div>
    </Section>
  );
};
